import { IVideoInfo } from 'mggp-player';

export enum ChannelType {
  REGULAR_CHANNEL = 'regularChannel',
  DVR_CHANNEL = 'dvrChannel',
  VOD_CHANNEL = 'vodChannel',
}

export interface IChannel {
  getNextProgram: (current: IProgram) => IProgram | null;
  id: number;
  type: ChannelType;
  isLocked: boolean;
  isChannelControlsRestricted: boolean;
  currentProgram: IProgram | null;
  programs: IProgram[] | null;
}

export enum ProgramState {
  PAST = 0,
  CURRENT = 1,
  FUTURE = 2,
}

export enum PlayerState {
  ended = 0,
  playing = 1,
  paused = 2,
  buffering = 3,
  waiting = 5,
  unknownDich = -1,
}

export enum ContentType {
  tv_dvr = 'tv_dvr',
  tv_dvr_catchup = 'tv_dvr_catchup',
  tv_dvr_vod = 'tv_dvr_vod',
  m_ch = 'm_ch',
  m_ch_vod = 'm_ch_vod',
  tv_linear = 'tv_linear',
  tv_linear_vod = 'tv_linear_vod',
}

export interface IProgram {
  startTimestamp: number;
  endTimestamp: number;
  state: ProgramState;
  duration: number;
  channel: IChannel;
  virtualStream: IVideoInfo;
  virtualObjectId: string;
  objectId: number;
  clickedFromProgramsPanel: boolean;
}

export enum PluginState {
  idle = 'idle',
  onAir = 'onAir',
  timeshift = 'timeshift',
  catchup = 'catchup',
}

export const PLAYER_PROPERTY = {
  channelState: 'interactiveChannel:channelState',
  playingProgram: 'interactiveChannel:currentPlayingProgram',
  playingProgramDuration: 'interactiveChannel:currentProgramDuration',
  playingProgramTime: 'interactiveChannel:currentPlayingTime',
  currentProgramTime: 'epg:currentProgramTime',
  // catchupDescription: 'dvrChannel:catchupDescription',
  hideNextPrevButtons: 'hidePrevNextButtons',
  currentChannel: 'epg:currentChannel',
  currentTimestamp: 'epg:currentTimestamp',

  src: 'src',
  objectAudioId: 'objectAudioId',
  audioTrack: 'audioTrack',
  subtitles: 'subtitles',
  quality: 'quality',
  state: 'state',

  wssIgnoreStopEvent: 'wss:ignore:stopEvent',
  wssIgnoreVideoInfoEvent: 'wss:ignore:videoInfoEvent',
  dismissSeekToLiveAfterPause: 'vendor:dismissSeekToLiveAfterPause',
};

export const PLAYER_EVENT = {
  resetPlugin: 'interactiveChannel:reset',
  disablePlugin: 'live:disableDvrPlugin',
  contentBlocked: 'contentBlocked',
  currentProgramChanged: 'epg:currentProgramChanged',
  channelSwitch: 'epg:channelSwitch',
  playProgram: 'dvrChannel:playProgram',
  backOnAir: 'dvrChannel:backOnAir',
  seek: 'dvrChannel:seek',
  timeUpdate: 'player:timeUpdate',
  stateChange: 'property:state',
  positionChange: 'property:position',
  durationChange: 'property:duration',
  currentChannelChange: 'property:epg:currentChannel',
  mediaError: 'mediaError',
  currentProgramListUpdated: 'epg:currentProgramListUpdated',
};
